import { useAPPTranslation } from '~/i18n/useAPPTranslation'
import {
  Button,
  Flex,
  ModalContent,
  ModalHeader,
  ModalHeading,
  Stack
} from '@vtex/shoreline'

import clsx from 'clsx'

import * as S from './styles'
import s from '../styles.module.css'

import { SelectTags } from './SelectTags'
import { Screens } from './Screens'
import { useModal } from './hooks/useModal'
import { ScreenGroupModalProps } from './types'

export default function ScreenGroupModal(props: ScreenGroupModalProps) {
  const { t } = useAPPTranslation()
  const { open, isEditing, allowPlacesSelect, isStandard } = props
  const {
    handleClose,
    canConfirm,
    handleConfirm,
    selectedTags,
    setSelectedTags,
    selectedScreens,
    setSelectedScreens
  } = useModal(props)

  return (
    <S.ModalContainer open={open}>
      <ModalHeader className={s.modalHeaderContainer}>
        <ModalHeading>
          {t(
            `rm:campaign.create.ScreenGroups.Modal.title.${isEditing ? 'edit' : 'create'}`
          )}
        </ModalHeading>
        <Stack horizontal>
          <Button variant="tertiary" size="large" onClick={handleClose}>
            {t('rm:button.Cancel')}
          </Button>
          <Button
            variant="primary"
            size="large"
            disabled={!canConfirm}
            onClick={handleConfirm}
          >
            {t(
              `rm:campaign.create.ScreenGroups.Modal.confirmButton.${isEditing ? 'save' : 'create'}`
            )}
          </Button>
        </Stack>
      </ModalHeader>

      <ModalContent className={clsx(s.flexOne, s.overflowHidden)}>
        <Flex gap="var(--sl-space-5)" className={s.modalContent}>
          <SelectTags
            selectedTags={selectedTags}
            setSelectedTags={setSelectedTags}
          />

          <Screens
            selectedTags={selectedTags}
            selectedScreens={selectedScreens}
            setSelectedScreens={setSelectedScreens}
            allowPlacesSelect={allowPlacesSelect}
            isStandard={isStandard}
            isEditing={isEditing}
          />
        </Flex>
      </ModalContent>
    </S.ModalContainer>
  )
}
